import { render, staticRenderFns } from "./SurveyFromExcelUploader.vue?vue&type=template&id=2f96d366&scoped=true"
import script from "./SurveyFromExcelUploader.vue?vue&type=script&lang=js"
export * from "./SurveyFromExcelUploader.vue?vue&type=script&lang=js"
import style0 from "./SurveyFromExcelUploader.vue?vue&type=style&index=0&id=2f96d366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96d366",
  null
  
)

export default component.exports